import React from 'react';
import { connect } from 'react-redux';
import { useSpring, animated } from 'react-spring';
import styled, { css } from 'styled-components';
import Anvendelse from './Anvendelse';
import EtagerByggehojde from './EtagerByggehojde';
import { above, size } from '../../../style/util';
import { common } from '../../../style';
import { Times, List } from '../../common/Icons/Light';
import { neutral } from '../../../style/colors';
import { useMedia } from '../../../hooks/useMedia';
import BebyggelsesOmfang from './BebyggelsesOmfang';
import PlanensAlder from './PlanensAlder';
import SidebarButton from '../../common/Buttons/SidebarButton';
import {
  resetFilters,
  setActiveStyle as setActiveStyleAction,
} from '../../../store/actions';
import { activeStyle } from '../../../store/interfaces/state';

const Filter = (props: ITopbarPropType) => {
  const { toggled, onToggle, resetFilters, setActiveStyle } = props;
  const isSmallScreen = useMedia(
    [`(max-width: ${size.small}px)`],
    [true],
    false
  );
  const navAnimation = useSpring({
    config: { duration: 150 },
    right: !isSmallScreen ? (toggled ? '0px' : '-430px') : '0px',
    bottom: isSmallScreen ? (toggled ? '0vh' : '-40vh') : '0vh',
  });
  const wrapperStyle = {
    display: 'flex',
    alignItems: isSmallScreen ? 'flex-end' : 'flex-start',
    flexDirection: isSmallScreen ? ('column' as any) : ('row' as any),
    position: 'fixed' as any,
    left: isSmallScreen ? 0 : 'unset',
    bottom: 0,
    top: isSmallScreen ? 'unset' : 0,
    zIndex: 3,
    transition: '0.3s',
    pointerEvents: 'none' as any,
  };
  return (
    <animated.div style={{ ...wrapperStyle, ...navAnimation }}>
      <Sidebar toggled={toggled}>
        <SidebarHeader>
          <List />
          <h1>JUSTÉR VISNING</h1>
          <Times
            onClick={onToggle}
            color={neutral[600]}
            width={20}
            height={20}
            style={{
              marginLeft: 'auto',
              cursor: 'pointer',
            }}
          />
        </SidebarHeader>

        <Anvendelse />
        <BebyggelsesOmfang />
        <EtagerByggehojde />
        <PlanensAlder />
        <div
          style={{
            marginTop: 22,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <SidebarButton
            onClick={() => {
              resetFilters();
              setActiveStyle(activeStyle.generelAnvendelse);
            }}
            text={'NULSTIL FILTRE'}
            color={neutral[700]}
            backgroundColor={neutral[200]}
            borderBottom={`4px solid ${neutral[300]}`}
            marginLeft={'0'}
          />
        </div>
        <SeptimaDisclaimer>
          Lavet af Septima P/S for Erhvervsstyrelsen. Dette er en demoklient for
          visning af plandata. Data er ikke kontinuerlig opdateret og kan derfor
          være ufuldstændig.
        </SeptimaDisclaimer>
      </Sidebar>
    </animated.div>
  );
};

const Sidebar = styled.div`
  pointer-events: auto;
  background-color: ${common.backgroundColor};
  overflow-y: auto;
  height: 40vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  ${props =>
    props.toggled &&
    css`
      box-shadow: ${common.boxShadow};
    `}
  ${(above as any).small`
    height: 100%;
    width: 430px;
  `}
`;

const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  border-bottom: 2px solid ${neutral[200]};
  // background-color: ${neutral[200]};
  h1 {
    margin: 0;
    margin-left: 1em;
    padding: 0;
    letter-spacing: 0.05em;
  }
`;
const SeptimaDisclaimer = styled.div`
  padding: 5px 25px 25px 25px;
  margin-top: auto;
  font-size: 13px;
  color: ${neutral[400]};
`;

const mapDispatchToProps = dispatch => {
  return {
    resetFilters: () => {
      dispatch(resetFilters());
    },
    setActiveStyle: activeStyle => {
      dispatch(setActiveStyleAction(activeStyle));
    },
  };
};

interface ITopbarPropType {
  toggled: boolean;
  onToggle?: Function;
  resetFilters: Function;
  setActiveStyle: Function;
}
export default connect(
  null,
  mapDispatchToProps
)(Filter);
